// extracted by mini-css-extract-plugin
export var root = "y14s";
export var rootBeige = "Sg4T";
export var rootButton = "ipFw";
export var rootCol = "v4HW";
export var rootContainer = "_9Vfx";
export var rootHeading = "kfn3";
export var rootImage = "rbNu";
export var rootList = "Tty5";
export var rootListItem = "UiZG";
export var rootListItemIcon = "Os1U";
export var rootListItemText = "tpaz";
export var rootPicture = "_34lP";
export var rootPictureOnLeft = "gtwq";
export var rootSubheading = "a9HK";
export var rootText = "vp7i";
export var rootWave = "LUc5";
export var rootWhite = "B786";
export var rootWhite2 = "Klq8";